import {ApiConfigPort} from '../config/api-config-port';
import {HttpService} from '../../services/http-service';
import {CreateResult, DeleteResult, ListResult} from './lib-rest';

export class DnaApi {
  config: ApiConfigPort;


 public constructor(config: ApiConfigPort) {
    this.config = config;
  }

 public  async deleteDnaResult(animalId: string, labNumber: string): Promise<DeleteResult>  {
const url =  new URL('/animals/' + animalId + '/dna', this.config.host);
    const queryParamsList: { name: string, value: string }[] = [];
    queryParamsList.push({name: 'labNumber', value: labNumber});
  
    for (const queryParam of queryParamsList) {
url.searchParams.append(queryParam.name,queryParam.value);
    }

return (await HttpService.getAxiosClient().delete(url.toString())).data
  }

 public  async getDnaResult(animalId: string): Promise<ListResult<DnaController$DnaResult> >  {
const url =  new URL('/animals/' + animalId + '/dna', this.config.host);

return (await HttpService.getAxiosClient().get(url.toString())).data
  }

 public  async importDnaResultPOST(animalId: string, file: any): Promise<CreateResult>  {
const url =  new URL('/animals/' + animalId + '/dna', this.config.host);
    const queryParamsList: { name: string, value: string }[] = [];
    queryParamsList.push({name: 'file', value: file.toString()});
  
    for (const queryParam of queryParamsList) {
url.searchParams.append(queryParam.name,queryParam.value);
    }

return (await HttpService.getAxiosClient().post(url.toString())).data
  }

 public  async importDnaResultPUT(animalId: string, importDna: DnaController$ImportDnaResult): Promise<CreateResult>  {
const url =  new URL('/animals/' + animalId + '/dna', this.config.host);

return (await HttpService.getAxiosClient().put(url.toString(),JSON.stringify(importDna))).data
  }

}

export interface DnaController$DnaResult {
  labNumber: string;
  markers: string[];
  testDate: any;
}

export interface DnaController$ImportDnaResult {
  csv: string;
}

